import { render, staticRenderFns } from "./CuentasPaquetes.vue?vue&type=template&id=11aa8fe3"
import script from "./CuentasPaquetes.vue?vue&type=script&lang=js"
export * from "./CuentasPaquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports